<script>
    import { required, minLength } from "vuelidate/lib/validators";
    import Customers from '@/services/Customers';
    import validationMessages from '@/components/validations'
    import General from '@/services/General';

    export default {
        components:{
            validationMessages
        },
        props: {
            addressData: {
                type: Object,
                default: null
            },
        },
        watch: {
            addressData: function(newVal) {
                this.id_e = newVal.address_id;
                this.line1_e = newVal.line1;
                this.line2_e = newVal.line2;
                this.line3_e = newVal.line3;
                this.city_e = newVal.city;
                this.state_province_e = newVal.state_province;
                this.zip_e = newVal.zip;
                this.country_e = newVal.country;
                this.address_type_e = newVal.address_type;
                this.primary_e = newVal.primary;
                this.verified_e = newVal.verified;
                this.mailing_e = newVal.mailing;
                this.checked_primary()
                this.checked_verified()
                this.checked_mailing()
            }
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                id_e: '',
                line1_e: '',
                line2_e: '',
                line3_e: '',
                city_e: '',
                state_province_e: '',
                zip_e: '',
                country_e: '',
                address_type_e: '',
                primary_e: '',
                verified_e: '',
                mailing_e: '',
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                primary_checked: false,
                verified_checked: false,
                mailing_checked: false,
                countries:[],
                showLoader:false
            };
        },
        validations: {
            line1_e: {
                required,
                minLength: minLength(2),
            },
            line2_e: {
                required,
            },
            city_e: {
                required,
                minLength: minLength(2),
            },
            zip_e: {
                required
            },
            country_e: {
                required
            },
        },
        methods: {

            async editCustomerAddress(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {

                        await Customers.updateAddress(this.id_e,{
                            line1: this.line1_e,
                            line2: this.line2_e,
                            line3: this.line3_e,
                            city: this.city_e,
                            state_province: this.state_province_e,
                            zip: this.zip_e,
                            country: this.country_e,
                            address_type: this.address_type_e,
                            primary: this.primary_checked == true ? 'Y' : 'N',
                            verified: this.verified_checked == true ? 'Y' : 'N',
                            mailing: this.mailing_checked == true ? 'Y' : 'N',
                            csrf_token: this.csrf_token
                        }).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg("Changes not saved")
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false;
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Changes not saved")
                    }
                }
                this.tryingToEdit = false;
            },

            checked_primary(){
                this.primary_checked = this.primary_e == 'Y' ? true : false;
            },
            checked_verified(){
                this.verified_checked = this.verified_e == 'Y' ? true : false;
            },
            checked_mailing(){
                this.mailing_checked = this.mailing_e == 'Y' ? true : false;
            },
            refreshData() {
                this.$emit('onRefresh') //event from parent
            },
            closeModal() {
                this.showModal = false;
            },

          async getCountry() {
            this.showLoader = true;
            try {
              await General.getCountry({
              }).then((response) => {
                this.countries = this.preferredCountryOrder(response.data, 'name');
              }).catch(error => {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.failedmsg(this.error)
              }).finally(() => {
                 this.showLoader = false;
              })

            } catch (error) {
              this.error = error.response.data.error ? error.response.data.error : "";
              this.failedmsg(this.error)
            }
          },

          modalShown(){
              this.getCountry()
          }

        }
    };
</script>

<template>
    <b-modal v-model="showModal" @shown="modalShown()" id="address_edit" title="Edit Customer Address" title-class="font-18" centered>
        <form @submit.prevent="editCustomerAddress">

            <b-form-group label="Street Name" label-for="formrow-streetname-input" class="mb-3">
                <b-form-input
                        v-model.trim="line1_e"
                        type="text"
                        id="line1_e"
                        aria-describedby="line1_e-feedback"
                        :class="{
                      'is-invalid': submitted && $v.line1_e.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Street Name'" :validationName="$v.line1_e"></validationMessages>
            </b-form-group>

            <b-form-group label="House Number" label-for="formrow-housenumber-input" class="mb-3">
                <b-form-input
                        v-model.trim="line2_e"
                        type="text"
                        id="line2_e"
                        aria-describedby="line2_e-feedback"
                        :class="{
                      'is-invalid': submitted && $v.line2_e.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'House Number'" :validationName="$v.line2_e"></validationMessages>
            </b-form-group>

            <b-form-group label="Additional Address" label-for="formrow-additional-input" class="mb-3">
                <b-form-input
                        v-model.trim="line3_e"
                        type="text"
                        id="line3_e"
                        aria-describedby="line3_e-feedback"
                >
                </b-form-input>
            </b-form-group>

            <b-form-group label="City" label-for="formrow-city-input" class="mb-3">
                <b-form-input
                        v-model.trim="city_e"
                        type="text"
                        id="city_e"
                        aria-describedby="city_e-feedback"
                        :class="{
                      'is-invalid': submitted && $v.city_e.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'City'" :validationName="$v.city_e"></validationMessages>
            </b-form-group>

            <b-form-group label="State Province" label-for="formrow-stateprovince-input" class="mb-3">
                <b-form-input
                        v-model.trim="state_province_e"
                        type="text"
                        id="state_province_e"
                        aria-describedby="stateprovince-feedback"
                >
                </b-form-input>
            </b-form-group>

            <b-form-group label="Zip" label-for="formrow-zip-input" class="mb-3">
                <b-form-input
                        v-model.trim="zip_e"
                        type="text"
                        id="zip_e"
                        aria-describedby="zip-feedback"
                        :class="{
                      'is-invalid': submitted && $v.zip_e.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Zip'" :validationName="$v.zip_e"></validationMessages>
            </b-form-group>

           <!-- <b-form-group label="Country" label-for="formrow-country-input" class="mb-3">
                <b-form-input  v-if="!showLoader"
                        v-model.trim="country_e"
                        type="text"
                        id="country_e"
                        aria-describedby="country-feedback"
                        :class="{
                      'is-invalid': submitted && $v.country_e.$error,
                    }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Country'" :validationName="$v.country_e"></validationMessages>
            </b-form-group> -->

            <b-form-group label="Country" label-for="formrow-country-input" class="mb-3">
                <select v-model="country_e" class="form-select" :class="{ 'is-invalid': submitted && $v.country_e.$error, }"  >
                    <option v-for="country in countries" :key="country.name" :value="country.alpha2code">{{country.name}}</option>
                      <validationMessages v-if="submitted" :fieldName="'Country'" :validationName="$v.country_e"></validationMessages>
                </select>
            </b-form-group>

            <b-form-group label="Address Type" label-for="formrow-address_type-input" class="mb-3">
                <select v-model="address_type_e" class="form-select">
                    <option value="unknown">Unknown</option>
                    <option value="home">Home</option>
                    <option value="business">Business</option>
                </select>
            </b-form-group>

            <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3" >
                    <input v-model="primary_checked"
                            type="checkbox"
                            class="form-check-input"
                            id="primaryAddress"
                    />
                    <label class="form-check-label" for="primaryAddress">Primary Address</label>
                </div>
            </b-form-checkbox-group>

            <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3" >
                    <input v-model="verified_checked"
                           type="checkbox"
                           class="form-check-input"
                           id="verifiedAddress"
                    />
                    <label class="form-check-label" for="verifiedAddress">Verified Address</label>
                </div>
            </b-form-checkbox-group>

            <b-form-checkbox-group>
                <div class="form-check form-switch form-switch-lg mb-3" >
                    <input v-model="mailing_checked"
                           type="checkbox"
                           class="form-check-input"
                           id="mailingAddress"
                    />
                    <label class="form-check-label" for="mailingAddress">Mailing Address</label>
                </div>
            </b-form-checkbox-group>
            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="editCustomerAddress" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Change</b-button>
        </template>
    </b-modal>
</template>